import { useEffect, useState } from "react";
import { IPageTravelGroupProps } from "../../properties/GroupProperties";

const PageTravelGroup = ({
  isImageProcessing,
  handleImageProcessing,
  initialTotalPageNumber,
  pageNumber,
  setPageNumber,
  setImageReady,
}: IPageTravelGroupProps) => {
  const [totalPageNumber, setTotalPageNumber] = useState<number>(0);
  const [newPageNumber, setNewPageNumber] = useState<number>(0);

  useEffect(() => {
    if (!initialTotalPageNumber) return;
    setTotalPageNumber(initialTotalPageNumber);
  }, [initialTotalPageNumber]);

  useEffect(() => {
    setNewPageNumber(pageNumber + 1);
  }, [pageNumber]);

  const handlePageChange = (newPage: number) => {
    if (isImageProcessing) {
      handleImageProcessing();
    } else {
      setPageNumber(newPage);
      setImageReady(false);
    }
  };

  return (
    <div className="ptg-row">
      <button
        type="button"
        className="ptg-btn"
        aria-label="Previous page"
        disabled={pageNumber <= 0}
        onClick={() => handlePageChange(pageNumber - 1)}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <div className="ptg-count">
        <span className="ptg-count-cur">{pageNumber + 1}</span>
        <span className="ptg-count-sep">/</span>
        <span className="ptg-count-total">{totalPageNumber}</span>
      </div>
      <button
        type="button"
        className="ptg-btn"
        aria-label="Next page"
        disabled={pageNumber >= totalPageNumber - 1}
        onClick={() => handlePageChange(pageNumber + 1)}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
      {/* The jump-to-page field only earns its space on long lists; a handful of
          pages is served by prev/next + the indicator alone. */}
      {totalPageNumber > 7 ? (
        <input
          className="ptg-input"
          type="number"
          aria-label="Go to page"
          value={Number.isNaN(newPageNumber) ? "" : newPageNumber}
          onChange={(e) => {
            setNewPageNumber(parseInt(e.target.value));
          }}
          onKeyDown={(e) => {
            if (
              isNaN(newPageNumber) ||
              newPageNumber <= 0 ||
              newPageNumber > totalPageNumber
            )
              return;
            if (e.key === "Enter") {
              handlePageChange(newPageNumber - 1);
            }
          }}
        />
      ) : null}
    </div>
  );
};

export default PageTravelGroup;
